import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { updateAbstractEmailApiSettings } from '../../../redux/actions/apiSettings';
import Loader from '../../Loader';

const Abstract = ({ loading, emailApis }) => {
	const dispatch = useDispatch();
  const [disabledBtnConfirm, setDisabledBtnConfirm] = useState(false);
	const [abstractForm, setAbstractForm] = useState({
		apiKey: '',
		approveForWebmail: false,
		type: 'abstract',
	});

	useEffect(() => {
		if (emailApis?.abstract) {
			emailApis.abstract.type = 'abstract';
			setAbstractForm(emailApis.abstract);
		}
	}, [emailApis]);

  useEffect(()=> {
    if (abstractForm?.apiKey?.length === 0 ) {
      setDisabledBtnConfirm(true);
      // console.log("The btn true vlaue:::===>>>", disabledBtnConfirm)
    } else {
      setDisabledBtnConfirm(false);
      // console.log("The btn false vlaue:::===>>>", disabledBtnConfirm)
    } 
  },[abstractForm])

	const handleAbstractApiFrom = (e) => {
		e.preventDefault();
		if (abstractForm.apiKey.trim()) {
			dispatch(updateAbstractEmailApiSettings(abstractForm));
		} else {
			toast.error('Please enter api key');
		}
	};

	return (
		<>
			{loading && <Loader />}
			<div id='tab-3' className='tab-content'>
				<div className='abstractTabContent'>
        <div className="contentInputWrapers">
					<p className='tabHeadingP'>Add Abstract API key</p>
          <input
							type='text'
							className='inputBox'
							placeholder='Enter your API key'
							value={abstractForm.apiKey}
							onChange={(e) =>
								setAbstractForm({ ...abstractForm, apiKey: e.target.value })
							}
						/>
        </div>
					<div className='fieldWrapers tabsSec'>
					
						<span className='optionButton'>
							<span className='btntext'>Approve for webmail</span>
							<label className='switch'>
								<input
									type='checkbox'
									defaultChecked={abstractForm.approveForWebmail}
									className={abstractForm.approveForWebmail ? 'checked' : ''}
									onChange={(e) =>
										setAbstractForm({
											...abstractForm,
											approveForWebmail: !abstractForm.approveForWebmail,
										})
									}
								/>
								<span className='slider round'></span>
							</label>{' '}
						</span>

            {/* {console.log("The value is at this". abstractForm)} */}

						<button className='apiBtn' disabled={disabledBtnConfirm} onClick={handleAbstractApiFrom}>
							Confirm
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

export default Abstract;
